// Shared particle effects service for tap and burst particles
export interface TapParticle {
  id: number;
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  emoji: string;
  scale: number;
}

export interface BurstParticle {
  id: number;
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  color: string;
  rotation: number;
  rotationSpeed: number;
}

const tapEmojis = ['✨', '💫', '⭐', '🌟', '💥', '🎯'];
let particleIdCounter = 0;

export const particleEffectsService = {
  // Create tap explosion particles
  createTapParticles: (x: number, y: number, strength: number = 1): TapParticle[] => {
    const particleCount = Math.floor(4 + strength * 3);
    const newParticles: TapParticle[] = [];
    
    for (let i = 0; i < particleCount; i++) {
      const angle = (Math.PI * 2 * i) / particleCount;
      const speed = 0.002 + Math.random() * 0.003 * strength;
      newParticles.push({
        id: particleIdCounter++,
        x: x + (Math.random() - 0.5) * 0.05,
        y: y + (Math.random() - 0.5) * 0.05,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: 0,
        maxLife: 800 + Math.random() * 400,
        emoji: tapEmojis[Math.floor(Math.random() * tapEmojis.length)],
        scale: 0.8 + Math.random() * 0.4 * strength,
      });
    }
    return newParticles;
  },

  // Create success burst particles
  createBurstParticles: (x: number, y: number): BurstParticle[] => {
    const particleCount = 8;
    const newParticles: BurstParticle[] = [];
    
    for (let i = 0; i < particleCount; i++) {
      const angle = (Math.PI * 2 * i) / particleCount;
      const speed = 0.003 + Math.random() * 0.002;
      newParticles.push({
        id: particleIdCounter++,
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: 0,
        maxLife: 1200 + Math.random() * 800,
        color: `hsl(${Math.random() * 360}, 80%, 60%)`,
        rotation: Math.random() * 360,
        rotationSpeed: (Math.random() - 0.5) * 5,
      });
    }
    return newParticles;
  },

  // Update particle positions
  updateTapParticles: (particles: TapParticle[]): TapParticle[] => {
    return particles
      .map(particle => ({
        ...particle,
        x: particle.x + particle.vx,
        y: particle.y + particle.vy,
        life: particle.life + 16,
        vy: particle.vy + 0.00008, // Gravity
      }))
      .filter(particle => particle.life < particle.maxLife);
  },

  updateBurstParticles: (particles: BurstParticle[]): BurstParticle[] => {
    return particles
      .map(particle => ({
        ...particle,
        x: particle.x + particle.vx,
        y: particle.y + particle.vy,
        life: particle.life + 16,
        rotation: particle.rotation + particle.rotationSpeed,
        vy: particle.vy + 0.0001, // Gravity
      }))
      .filter(particle => particle.life < particle.maxLife);
  },

  // Reset particle ID counter (useful for tests or when needed)
  resetIdCounter: () => {
    particleIdCounter = 0;
  }
}; 